import { createSignal, For, Show, createEffect, onMount, Component } from 'solid-js';
import { fetchGet } from './API';
import { CMS } from './cms';
import Graph from './Graph';

type Tab = "list"|"graph";
type Node = {
    name: string;
    id: number
};
type RelationshipsTabProps = {
    artist: Node;
};

export const RelationshipsTab : Component<any> = (props: RelationshipsTabProps) => {
    const [tab, setTab] = createSignal<Tab>("graph");
    const [graphArtistId, setGraphArtistId] = createSignal<number>(props.artist.id);
    const [previousGraphArtistId, setPreviousGraphArtistId] = createSignal<number>();
    const [data, setData] = createSignal<any>();
    const [graphArtistsViewed, setGraphArtistsViewed] = createSignal<Node[]>([{ id: props.artist.id, name: props.artist.name }]);
    const onNodeClicked = (node: Node) => {
        setPreviousGraphArtistId(graphArtistId());
        setGraphArtistId(node.id);
        addToHistory(node);
    };
    const addToHistory = (node: Node) => {
        const viewed = graphArtistsViewed();
        if (!viewed.some((x: Node) => x.id == node.id)) {
            setGraphArtistsViewed(viewed.concat([node]));    
        }
    };
    const getData = async(artistId: number) => {
        const response = await fetchGet("/Artist/RelationshipsJson", { id: artistId });
        const json = await response.json();
        return json.Data;
    };
    const switchToGraphArtist = (node: Node) => {
        setPreviousGraphArtistId(graphArtistId());
        setGraphArtistId(node.id);
        addToHistory(node);
    }
    const removeFromHistory = (item: Node) => {
        if (item.id == props.artist.id) {
            return;
        }
        const remaining = graphArtistsViewed().filter((x: Node) => x.id != item.id);
        setGraphArtistsViewed(remaining);
    };
    const getHistoryItemColour = (item: Node) => {
        if (item.id == graphArtistId()) {
            return "red";
        }
        if (item.id == previousGraphArtistId()){
            return "blue";
        }
        return "#000";
    };
    onMount(() => {
        createEffect(async () => {
            const _data = await getData(graphArtistId());
            setData(_data);
        });
    });
    return (
        <section class="tabs air-gap" style="margin: 40px;">
            <ul class="list-inline tablinkgroup unselectable">
                <li onClick={() => setTab("graph")} classList={{ ["active"]: tab() == "graph"}}>
                    <span class="tablink">
                        <CMS id="tab::artists">Graph</CMS>
                    </span>
                </li>
                <li onClick={() => setTab("list")} classList={{ ["active"]: tab() == "list"}}>
                    <span class="tablink">
                        <CMS id="tab::artists">List</CMS>
                    </span>
                </li>
            </ul>
            <div style="border: 1px solid #ccc; padding: 10px;">
                <div class="row">
                    <div class="col-md-10">
                        <Show when={tab() == "graph"}>
                            <Show when={data()}>
                                <Graph data={data} nodeClicked={(node) => onNodeClicked(node)}></Graph>                
                            </Show>
                        </Show>
                        <Show when={tab() == "list"}>
                            <Show when={data()}>
                                <ul>
                                    <For each={data().Artists}>{(item: any) =>
                                        <li>
                                            {item.Source.Name} was the <b>{item.Edge.Name}</b> <span style="text-decoration: underline;" onClick={() => switchToGraphArtist({ id: parseInt(item.Target.Id), name: item.Target.Name })}>{item.Target.Name}</span>
                                        </li>
                                    }</For>
                                </ul>                                            
                            </Show>
                        </Show>
                    </div>
                    <div class="col-md-2">
                        <h4>
                            Artists viewed
                        </h4>
                        <ul>
                            <For each={graphArtistsViewed()}>{(item: Node) =>
                                <li>
                                    <i class="fa fa-trash-o" style="margin-right: 10px;" onclick={(e) => { e.preventDefault(); removeFromHistory(item); }}></i>
                                    <span style={{ color: getHistoryItemColour(item), "text-decoration": "underline" }} onClick={() => switchToGraphArtist({ id: item.id, name: item.name }) }>{item.name}</span>
                                </li>
                            }</For>
                        </ul>
                    </div>
                </div>
            </div>                                    
        </section>
    );
}